export default __webpack_public_path__ + "f4ec525e2579712335d90b6f595cf359.svg";